import { supabase } from "../supabaseClient";
import { buildProductPayload } from "../utils/productUtils";

const COLUMNS = [
  "id",
  "name",
  "slug",
  "description",
  "price",
  "image_url",
  "category",
  "business_line",
  "stock",
  "featured",
  "is_active",
  "created_at",
  "updated_at",
].join(", ");

const COLUMNS_WITH_SIZES = `${COLUMNS}, product_sizes (id, product_id, size_name, price, created_at)`;

const normalizeSizes = (sizes = []) =>
  (Array.isArray(sizes) ? sizes : [])
    .map((size) => ({ size_name: String(size.size_name || "").trim(), price: Number(size.price) || 0 }))
    .filter((size) => size.size_name);

export const getProductsAdmin = async () => {
  const { data, error } = await supabase.from("products").select(COLUMNS_WITH_SIZES).order("created_at", { ascending: false });
  if (error) throw error;
  return data || [];
};

const replaceProductSizes = async (productId, sizes) => {
  const { error: deleteError } = await supabase.from("product_sizes").delete().eq("product_id", productId);
  if (deleteError) throw deleteError;

  const rows = normalizeSizes(sizes).map((size) => ({ ...size, product_id: productId }));
  if (!rows.length) return [];

  const { data, error } = await supabase.from("product_sizes").insert(rows).select();
  if (error) throw error;
  return data || [];
};

export const createProductAdmin = async (product, sizes = []) => {
  const payload = buildProductPayload(product);

  const { data, error } = await supabase.from("products").insert([payload]).select(COLUMNS).single();
  if (error) throw error;
  const productSizes = await replaceProductSizes(data.id, sizes);
  return { ...data, product_sizes: productSizes };
};

export const updateProductAdmin = async (id, updates, sizes) => {
  const isFullProductUpdate = ["name", "description", "price", "image_url", "category", "business_line", "stock"].some(
    (field) => Object.prototype.hasOwnProperty.call(updates, field)
  );
  const cleanPayload = isFullProductUpdate
    ? buildProductPayload({ ...updates, slug: updates.slug || undefined })
    : Object.fromEntries(Object.entries(updates).filter(([, value]) => value !== undefined));

  const { data, error } = await supabase.from("products").update(cleanPayload).eq("id", id).select(COLUMNS).single();
  if (error) throw error;
  const productSizes = sizes === undefined ? data.product_sizes : await replaceProductSizes(id, sizes);
  return { ...data, product_sizes: productSizes };
};

export const deleteProductAdmin = async (id) => {
  const { error } = await supabase.from("products").delete().eq("id", id);
  if (error) throw error;
  return true;
};
